import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
 * tailwind-merge has to be told the tokens, because it decides what conflicts
 * with what by reading the class name alone.
 *
 * Left to its defaults it reads `text-bodysm` as a *colour* — the name is not
 * one of Tailwind's stock font sizes, and colour is the fallback — so a button
 * carrying `text-surface text-bodysm` lost its colour and inherited `ink`,
 * which on the near-black primary button is black text on black. Nothing
 * errors; the class is simply gone from the DOM.
 *
 * Every custom namespace in tokens.css therefore has to be listed here. A token
 * added there and forgotten here fails the same silent way.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['3xs', '2xs', 'bodysm', 'md', 'heading', 'num', 'title', 'display', 'hero'],
      radius: ['control', 'card', 'panel', 'modal'],
      shadow: ['button', 'card', 'card-hover', 'popup', 'modal', 'knob'],
      spacing: ['card', 'section'],
      ease: ['out-quint'],
    },
  },
});

/** Merge conditional class lists, letting later Tailwind utilities win. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
